var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fix-location",on:{"click":_vm.fixLocation}},[_c('img',{attrs:{"src":require("../../../../assets/images/icon_dw.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }